// src/components/ContactSocials.js
import React from 'react';

// Social icons – zelfde als in de Footer
import { ReactComponent as FacebookIcon } from '../assets/icon-facebook.svg';
import { ReactComponent as InstagramIcon } from '../assets/icon-instagram.svg';
import { ReactComponent as LinkedInIcon } from '../assets/icon-linkedin.svg';

// Socials-blok onder de contactgegevens: in de contact-modal en op /contact.
function ContactSocials() {
  return (
    <>
      <h3 style={{ margin: '0 0 0.25rem 0' }}>Socials</h3>
      <p style={{ margin: 0, marginBottom: '0.75rem', color: '#6c757d' }}>
        Volg ons ook op social media voor inspiratie en updates:
      </p>

      <div className="social-icons" style={{ display: 'flex', gap: '0.75rem' }}>
        <a
          href="https://www.facebook.com/Doorloopjes"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
          title="Facebook"
        >
          <FacebookIcon />
        </a>
        <a
          href="https://www.linkedin.com/showcase/doorloopjes"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn"
          title="LinkedIn"
        >
          <LinkedInIcon />
        </a>
        <a
          href="https://www.instagram.com/doorloopjes.nl/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
          title="Instagram"
        >
          <InstagramIcon />
        </a>
      </div>
    </>
  );
}

export default ContactSocials;
